export default {
  styleOverrides: {
    root: {
      fontSize: 20,
      textTransform: 'none',
    },
  },
};
